/** Landing route of training mode. Dependency-free so edge middleware can import it. */
export const TRAINING_BASE_PATH = '/training';
